import { authClient } from "./authClient";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) output[i] = rawData.charCodeAt(i);
  return output;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

async function ensureServiceWorker() {
  const existing = await navigator.serviceWorker.getRegistration("/sw.js");
  if (existing) return existing;
  return navigator.serviceWorker.register("/sw.js");
}

export async function getPushSubscription() {
  if (!isPushSupported()) return null;
  const reg = await ensureServiceWorker();
  return reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error("Push not supported on this browser.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications permission denied.");

  const { data } = await authClient.get("/api/config/push-key");
  const publicKey = data?.public_key;
  if (!publicKey) throw new Error("Server push key unavailable.");

  const reg = await ensureServiceWorker();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  const raw = sub.toJSON();
  await authClient.post("/api/admin/push/subscribe", {
    endpoint: raw.endpoint,
    keys: raw.keys,
  });
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await getPushSubscription();
  if (!sub) return;
  const raw = sub.toJSON();
  try {
    await authClient.request({
      url: "/api/admin/push/subscribe",
      method: "DELETE",
      data: { endpoint: raw.endpoint, keys: raw.keys },
    });
  } catch (_) {}
  try {
    await sub.unsubscribe();
  } catch (_) {}
}

export async function sendTestPush() {
  return authClient.post("/api/admin/push/test");
}
